import BaseCommand from "@/models/api/commands/BaseCommand";

export class UpdateSummaryPrintCommand extends BaseCommand {
  CommandName = "UpdateSummaryPrint";
  Command: boolean;
  constructor(sessionId: string, operationId: string, summaryPrint: boolean) {
    super(sessionId, operationId);
    this.Command = summaryPrint;
  }
}
